export const CANCEL_ORDER_PAYMENT_TYPE = "cancelled";
